import { render, staticRenderFns } from "./totalPatiens.vue?vue&type=template&id=1a2b8c80"
import script from "./totalPatiens.vue?vue&type=script&lang=js"
export * from "./totalPatiens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports